// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"InfoTooltip_tooltipContainer__tB++7","infoIcon":"InfoTooltip_infoIcon__hfpS3","tooltipText":"InfoTooltip_tooltipText__l6R4x"};